import React, { Component } from 'react';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocCutomEntitiesDeleteaLL extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Delete All Custom RegEx</h3>
                <code className="api-definition">
                    <span className="delete-badge">DELETE</span>&nbsp;{urlHandler.API_ENDPOINT_V1_REGEX_DELETE_ALL}
                </code>
                <div className="description">
                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                    <br/>
                    <b>Delete All Custom RegEx</b><br/>
                    <br/>
                    The delete-all endpoint allows for a user to clear all patterns. This is intended for users who are having data issues or want to start over.
                </div>

                <h4 className="heading-2">Response</h4>

                <h4 className="heading-3">Response object</h4>
                <div className="description">
                    The response object contains a information on the status of the Custom RegEx change as well as accessory information about the change.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">code</td>
                        <td className="meaning">A specific code indicating a success or failure.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">message</td>
                        <td className="meaning">A simple message about what was completed.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>details</i></td>
                        <td className="meaning">A list of details regarding any issues with the request. May be empty if the request is a success.</td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_REGEX_DELETE_ALL, null, 3)}
                    </pre>
                </div>
            </div>
        );
    }
}

export default DocCutomEntitiesDeleteaLL;